import { Country } from "./ParsingPlugin/types";
import React from "react";
import Main from "./ParsingPlugin/Main";

const App: React.FC = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const website = urlParams.get("website");
  const vertical = urlParams.get("vertical");
  const countries = urlParams.get("countries");
  const user = urlParams.get("user");

  if (!website || !vertical || !countries || !user) {
    return <div>Not allowed</div>;
  }
  return (
    <Main
      website={website}
      vertical={vertical}
      countries={countries.split(",") as Country[]}
      user={user}
    />
  );
};

export default App;
